// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCarouselProductStyles } from "@steiner/Overrides/Components/ProductCarouselProduct";
import Plus from "@steiner/XDL/Icons/Plus";
import { ellipsis } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

productCarouselProductStyles.productImageStyles = {
    linkWrappingImage: {
        css: css`
            width: 95px;
            height: 95px;
        `,
    },
    img: {
        width: "95px",
        height: "95px",
    },
};

productCarouselProductStyles.productBrandWrapper = {};

productCarouselProductStyles.productDescriptionStyles = {
    productDetailLink: {
        mergeCss: true,
        typographyProps: {
            size: 14,
            lineHeight: "18px",
            css: css`
                ${ellipsis(3)}
            `,
        },
        css: css`
            min-height: 54px;
            margin-bottom: 8px;
            align-items: baseline;
        `,
    },
};

productCarouselProductStyles.productPriceWrapper = {};

productCarouselProductStyles.productPartNumbersStyles = {};

productCarouselProductStyles.addToListWrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
    `,
};

productCarouselProductStyles.productAddToListLinkStyles = {
    link: {
        icon: {
            iconProps: {
                src: Plus,
                size: 12,
            },
        },
        typographyProps: {
            size: 12,
            lineHeight: "15px",
        },
    },
};

productCarouselProductStyles.productAddToCartButtonStyles = {
    css: css`
        width: 100%;
        min-height: 24px;
    `,
};

productCarouselProductStyles.quantityOrderedStyles = {
    css: css`
        &&& {
            height: 28px;
        }
    `,
    cssOverrides: {
        formInputWrapper: css`
            height: 28px;
        `,
    },
    container: {
        css: css`
            height: 28px;
        `,
    },
};